module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-event-14fdeadc.svg";